import { Link } from 'react-router-dom';
import './NotFound.css';

function NotFound() {
  return (
    <div className="not-found">
      <div className="page-header">
        <h1>404</h1>
        <div className="section-divider"></div>
      </div>
      <section className="section">
        <div className="container not-found__content">
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist.</p>
          <Link to="/" className="btn-primary">Return Home</Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
